import { render, staticRenderFns } from "./FullPageScroll.vue?vue&type=template&id=2e73b8f6&scoped=true&"
import script from "./FullPageScroll.vue?vue&type=script&lang=js&"
export * from "./FullPageScroll.vue?vue&type=script&lang=js&"
import style0 from "./FullPageScroll.vue?vue&type=style&index=0&id=2e73b8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e73b8f6",
  null
  
)

export default component.exports